// extracted by mini-css-extract-plugin
export var box = "_5b-1";
export var checkboxRow = "_5b-8";
export var checked = "_5b-2";
export var descriptionSpacer = "_5b-a";
export var disabled = "_5b-3";
export var icon = "_5b-6";
export var input = "_5b-0";
export var labelSpacer = "_5b-9";
export var medium = "_5b-5";
export var small = "_5b-4";
export var text = "_5b-7";